module.exports = "/assets/e82c28e52fe22e494c7e84809d853a8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/WU.png
// module id = 1973
// module chunks = 0